module.exports = __webpack_public_path__ + "img/hakhak_app_4.67269ab7.png";